const style = require("../../../../../components/report/report-style");
const css = style.get();

// Helpers
const formatCurrency = (value) => value.toLocaleString("en-US", { style: "currency", currency: "USD" });
const parseAmount = (val) => parseFloat(String(val || "0").replace(/[$,]/g, "")) || 0;
const getRowClass = (i) => (i % 2 === 0 ? "" : css.trGray);

// Configuración de las diferencias entre cuentas por pagar y cuentas por cobrar
const REPORT_CONFIG = {
  payable: {
    cssClass: "accountsPayable-one",
    entityKey: "provider",
    reportTitle: "Account Payable",
    docType: "Bills",
    description: "This is a financial document that provides a summary of the outstanding invoices and bills that a company owes to one Provider.",
    headers: ["Date", "Category", "code", "Due Date", "Due Amount", "Original Amount"],
    colspan: 6,
    getClickPayload: (code) => `{"click": [{"dest":"ripple"}, {"dest":"report", "elem":"fullcont", "act":"jump", "actJump":"goToPurchase", "dtId":"purchase-dt", "toSearch":"${code}"}]}`,
    renderRow: (item, clickHtml) => `
      <td ${css.td}>${item.date}</td>
      <td ${css.td}>${item.category}</td>
      <td class='tdClick' ${css.td} ${clickHtml}>${item.code}</td>
      <td ${css.td}>${item.due_date}</td>
      <td ${css.td}>${item.due_amount}</td>
      <td ${css.td}>${item.original_amount}</td>
    `
  },
  receivable: {
    cssClass: "accountsReceivable-one",
    entityKey: "customer",
    reportTitle: "Account Receivable",
    docType: "Invoices",
    description: "This is a financial document that provides information about money owed to a company by its customers or clients for goods or services provided on credit.",
    headers: ["Date", "code", "Due Date", "Original Amount", "Due Amount"],
    colspan: 5,
    getClickPayload: (code) => `{"click": [{"dest":"ripple"}, {"dest":"report", "act":"jump", "actJump":"goToSales", "dtId":"sale-dt", "toSearch":"${code}"}]}`,
    renderRow: (item, clickHtml) => `
      <td ${css.td}>${item.date}</td>
      <td class='tdClick' ${css.td} ${clickHtml}>${item.code}</td>
      <td ${css.td}>${item.due_date}</td>
      <td ${css.td}>${item.original_amount}</td>
      <td ${css.td}>${item.due_amount}</td>
    `
  }
};

// Generador Unificado del Reporte Individual
function buildOneDocument(topRows, detailRows, type) {
  if (!topRows?.length) return "";
  
  const conf = REPORT_CONFIG[type];
  const top = topRows[0];
  const entityName = top[conf.entityKey];

  // Estructura por defecto si no hay detalles
  const ages = detailRows?.length ? detailRows : [{
    name: entityName,
    ageDueAmount: null,
    unpaidBill: "[]",
    overdue_age: "",
  }];

  let html = `
    <div class="dataCont ${conf.cssClass}">
      <div ${css.title}>${top.company_name}</div>
      <div ${css.subtitle}>${entityName} ${conf.reportTitle} Aging Report As Of ${top.current_dateTime}</div>
      <h2 ${css.f15}>${ages[0].name} Unpaid ${conf.docType}: ${conf.description}</h2>
      <table ${css.table}>
        <tr>
          ${conf.headers.map(h => `<th ${css.th}>${h}</th>`).join("")}
        </tr>
  `;

  // Validación de estado vacío
  if (ages[0].ageDueAmount == null) {
    return html + `
        <tr>
          <td ${css.td} colspan="${conf.colspan}"><div align="center"><h3>No Due ${conf.docType} Were Found.</h3></div></td>
        </tr>
      </table></div> <div class="report-page"></div>
    `;
  }

  let totalDue = 0;

  // Generación de filas
  ages.forEach((ageGrp) => {
    html += `
      <tr>
        <td ${css.td} colspan="${conf.colspan}" bgcolor="lightgray">
          <div align="center">
            <div style="font-weight: bold;">${ageGrp.overdue_age} ${ageGrp.ageDueAmount}</div>
          </div>
        </td>
      </tr>
    `;

    totalDue += parseAmount(ageGrp.ageDueAmount);
    
    // Parseo seguro
    let unpaidBills = [];
    try { unpaidBills = JSON.parse(ageGrp.unpaidBill); } catch (e) {}

    unpaidBills.forEach((bill, y) => {
      const clickHtml = `data-detail='${conf.getClickPayload(bill.code)}'`;
      html += `<tr ${getRowClass(y)}> ${conf.renderRow(bill, clickHtml)} </tr>`;
    });
  });

  // Fila de Totales
  html += `
      <tr>
        <td ${css.td} colspan="${conf.colspan - 1}">
          <div align="right"><div style="font-weight: bold;">Total Due</div></div>
        </td>
        <td ${css.td}>
          <div align="left"><div>${formatCurrency(totalDue)}</div></div>
        </td>
      </tr> 
    </table>
    </div> <div class="report-page"></div>
  `;

  return html;
}

// Exportaciones exactas para mantener la compatibilidad con el resto del sistema
export const generatePayableOneDocument = (top, detail) => buildOneDocument(top, detail, "payable");
export const generateReceivableOneDocument = (top, detail) => buildOneDocument(top, detail, "receivable");

// Se exportan estas partes por si otros módulos las consumen por separado (aunque ahora buildOneDocument hace todo)
export const generatePayableOneTop = (data) => buildOneDocument([data], [], "payable").split('<table')[0];
export const generateReceivableOneTop = (data) => buildOneDocument([data], [], "receivable").split('<table')[0];
export const generatePayableOneTable = (ages) => `<h2` + buildOneDocument([{}], ages, "payable").split('<h2')[1].split('</div> ')[0];
export const generateReceivableOneTable = (ages) => `<h2` + buildOneDocument([{}], ages, "receivable").split('<h2')[1].split('</div> ')[0];